<template>
   <el-dialog
      :visible.sync="dialogVisible"
      width="496px"
      center
      custom-class="concatDialogClass"
      @close="handleClose"
   >
      <div class="concatDialogClass-content">
         <p><i class="iconfont icon-error-circle-filled" style="color: #FF7800;"></i> &nbsp;抱歉，生态订单专区仅向海智会员供应商开放</p>
         <p style=" color: #555; font-size: 14px;font-weight:500;">如需帮助，请联系你的客户经理</p>
         <div class="concat-msg">
            <ul>
               <li class="manage">{{$store.state.salesInfoData.userName}}</li>
               <li><i class="iconfont icon-icon-shoujihao"></i> {{$store.state.salesInfoData.phone}}</li>
               <li><i class="iconfont icon-icon-zuojihao"></i> {{$store.state.salesInfoData.tel}}</li>
               <li>
                  <i class="iconfont icon-icon-zuojihaobeifen" style="font-size:12px"></i> 
                  <a href="javascript:void(0);" @click="handleClickEmail($store.state.salesInfoData.email)" style="color: #0863FF;">{{ $store.state.salesInfoData.email }}</a>
               </li>
            </ul>
         </div>
      </div>
   </el-dialog>
</template>

<script>
export default {
   head () {
      return {
         // title: "机加工订单-机加工询盘-钣金订单-铸造订单-冲压订单-注塑订单-最新询盘 ——HAIZOL海智在线",
         // meta: [
         //    { hid: 'keywords', name: 'keywords', content: "海智在线,机加工订单,机加工询盘,机加工B2B,零部件采购,非标件采购,工业大众点评,冲压订单,钣金订单,铸造订单,注塑订单,RFQ询盘" },
         //    { hid: 'description', name: 'description', content: "HAIZOL海智在线是一家专注于工业零部件领域的产业链综合服务平台，为零部件制造商提供订单对接、生产线改造、数字化管理、供应链金融等服务。" }
         // ]
      }
   },
   props:['concatDialogVisible'],
   data(){
      return {
         dialogVisible: this.concatDialogVisible,
      }
   },
   methods:{
      handleClickEmail(url) {
         window.location.href = `mailto:${url}`
         return false
      },
      // 关闭登录弹框
      handleClose () {
         this.dialogVisible = false
         this.$emit('closeConcatDialog',this.dialogVisible)
      },
    
   },
}
</script>

<style lang="scss" scoped>
::v-deep.concatDialogClass{
   border-radius: 8px;
   &-content{
      p{
         color: #333333;  
         font-size: 16px; 
         font-weight: 700;
         line-height: 24px;
         margin-bottom: 16px;
         text-align: center;
      }
      .concat-msg{
         border-radius: 4px;
         background: #FBFBFB;
         padding:24px;
         ul {
            color: #333333;
            line-height: 24px;
            li{
               width: 200px;
               margin: 0 auto;
               .iconfont{
                  font-size:16px;
                  color:#888888;
                  margin-right: 14px;
               }
            }
         }
         .manage{
            font-weight:600;
            margin-bottom: 14px;
            span{
               color: #666666; 
               font-size: 12px; 
               font-weight: 400;
               margin-left:8px;
            }
         }
      }
   }
   .el-dialog__header{
      padding:0;
   }
   .el-dialog__body{
      padding: 24px;
   }
   .el-dialog__headerbtn{
      top:28px;
      right:24px;
   }
}
</style>